export default __webpack_public_path__ + "media/images/document-dossier-g99-orange-papier-icone-6961-96-92c12020603d8fe2624fa54f48683597.png";